import {
  Component,
  ElementRef,
  HostListener,
  Input,
  Output,
  EventEmitter,
  signal,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasemapType, Basemap } from '../../canvas-maps.models';
import { CanvasToolbarIconComponent } from '../../../icons/canvas-toolbar-icon.component';

@Component({
  selector: 'lib-canvas-basemap-tool',
  standalone: true,
  imports: [CommonModule, CanvasToolbarIconComponent],
  template: `
    <div class="cv-tb-basemap">
      <button
        class="cv-tb__btn"
        [class.cv-tb__btn--active]="isOpen()"
        (click)="togglePanel($event)"
        title="Choose base map style"
        type="button"
        aria-haspopup="listbox"
        [attr.aria-expanded]="isOpen()"
      >
        <lib-canvas-toolbar-icon name="map"></lib-canvas-toolbar-icon>
      </button>

      <div class="cv-tb-basemap__panel" *ngIf="isOpen()" role="listbox" aria-label="Base map">
        <p class="cv-tb-basemap__label">Base map</p>
        <button
          *ngFor="let bm of basemaps"
          type="button"
          class="cv-tb-basemap__item"
          [class.cv-tb-basemap__item--active]="activeBasemap === bm.type"
          (click)="select(bm.type)"
          role="option"
          [attr.aria-selected]="activeBasemap === bm.type"
        >
          <span class="cv-tb-basemap__thumb cv-tb-basemap__thumb--{{ bm.type }}">
            <img
              *ngIf="bm.previewUrl"
              [src]="bm.previewUrl"
              [alt]="bm.name + ' preview'"
              loading="lazy"
            />
          </span>
          <span class="cv-tb-basemap__name">{{ bm.name }}</span>
          <lib-canvas-toolbar-icon
            *ngIf="activeBasemap === bm.type"
            name="check"
            [imgClass]="checkImgClass"
          ></lib-canvas-toolbar-icon>
        </button>
      </div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class BasemapToolComponent {
  readonly checkImgClass = 'cv-toolbar-icon-img--basemap-check';
  private readonly host = inject(ElementRef<HTMLElement>);

  @Input() activeBasemap: BasemapType = 'osm';
  @Input() basemaps: readonly Basemap[] = [];
  @Output() basemapChange = new EventEmitter<BasemapType>();

  isOpen = signal(false);

  togglePanel(event?: Event): void {
    event?.stopPropagation();
    this.isOpen.update((v) => !v);
  }

  select(type: BasemapType): void {
    this.basemapChange.emit(type);
    this.isOpen.set(false);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isOpen()) return;
    if (!this.host.nativeElement.contains(event.target as Node)) {
      this.isOpen.set(false);
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.isOpen.set(false);
  }
}
